(()=>{
  'use strict';
  const debounce=(fn,wait=250)=>{let timer;return(...args)=>{clearTimeout(timer);timer=setTimeout(()=>fn(...args),wait)}};
  const route=(value,fallback)=>{const base=value||fallback;return base.endsWith('.js')?base:`${base}.js`};
  const parseSection=(html,selector)=>{
    if(html==null)return '';
    const doc=new DOMParser().parseFromString(String(html),'text/html');
    const node=selector?doc.querySelector(selector):null;
    return node?node.innerHTML:doc.body.innerHTML;
  };

  class AntarCartNotification extends HTMLElement{
    constructor(){
      super();
      this.onOutside=this.onOutside.bind(this);
      this.onKeydown=this.onKeydown.bind(this);
      this.onChange=debounce(this.onChange.bind(this),220);
      this.addEventListener('click',event=>this.onClick(event));
      this.addEventListener('change',this.onChange);
      this.addEventListener('keydown',this.onKeydown);
    }
    connectedCallback(){
      this.querySelector('.cart-notification__close')?.addEventListener('click',()=>this.close());
      this.setAttribute('aria-hidden',String(!this.classList.contains('active')));
    }
    getSections(){return['cart-notification-product','cart-notification-subtotal','cart-notification-count','cart-notification-discount','cart-notification-recommendation']}
    getCount(state){
      const direct=Number(state?.item_count);
      if(Number.isFinite(direct))return direct;
      const section=state?.sections?.['cart-notification-count'];
      if(section!=null){const value=Number(String(section).replace(/<[^>]*>/g,'').trim());if(Number.isFinite(value))return value;}
      const live=Number(this.querySelector('#cart-notification-count')?.textContent||0);
      return Number.isFinite(live)?live:0;
    }
    syncState(count){
      const empty=count<1;
      this.querySelector('#min-cart-items')?.classList.toggle('no-js-inline',empty);
      this.querySelector('#empty__cart__button')?.classList.toggle('no-js-inline',empty);
      this.querySelector('.empty__cart__item')?.classList.toggle('no-js-inline',!empty);
      this.querySelector('.item__success_message')?.classList.toggle('no-js-inline',empty);
      this.querySelector('.item__empty_message')?.classList.toggle('no-js-inline',!empty);
      const live=this.querySelector('#cart-notification-count');if(live)live.textContent=String(count);
    }
    renderContents(state,{open=true}={}){
      const sections=state?.sections||{};
      this.getSections().forEach(id=>{
        const target=this.querySelector(`#${CSS.escape(id)}`)||document.getElementById(id);
        if(!target||sections[id]==null)return;
        target.innerHTML=parseSection(sections[id],`#${CSS.escape(id)}`);
      });
      const count=this.getCount(state);
      this.syncState(count);
      document.dispatchEvent(new CustomEvent('antar:cart-change',{detail:{count,cart:state}}));
      if(open)this.open();
    }
    open(){
      this.classList.add('animate','active');
      this.setAttribute('aria-hidden','false');
      document.body.classList.add('added__overlay');
      document.documentElement.classList.add('antar-cart-open');
      document.body.addEventListener('click',this.onOutside);
      requestAnimationFrame(()=>this.querySelector('.cart-notification__close')?.focus({preventScroll:true}));
    }
    close(){
      this.classList.remove('active');
      this.setAttribute('aria-hidden','true');
      document.body.classList.remove('added__overlay');
      document.documentElement.classList.remove('antar-cart-open');
      document.body.removeEventListener('click',this.onOutside);
    }
    onOutside(event){if(!this.contains(event.target)&&!event.target.closest?.('[data-antar-cart-trigger]'))this.close()}
    onKeydown(event){
      if(event.key==='Escape'){event.preventDefault();this.close();return;}
      if(event.key!=='Tab'||!this.classList.contains('active'))return;
      const focusable=[...this.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>el.offsetParent!==null);
      if(!focusable.length)return;
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
    onClick(event){
      const qtyButton=event.target.closest('.quantity__button');
      if(qtyButton){
        event.preventDefault();
        const wrapper=qtyButton.closest('.cart-notification__quantity-wrapper');
        const input=wrapper?.querySelector('.quantity__input');
        if(!input)return;
        const step=Math.max(1,Number(input.step)||1),min=Math.max(0,Number(input.min)||0),max=input.max?Number(input.max):Infinity;
        const next=Math.max(min,Math.min(max,(Number(input.value)||min)+(qtyButton.name==='minus'?-step:step)));
        input.value=String(next);this.updateQuantity(input.dataset.index,next,input.dataset.quantityVariantId);return;
      }
      const remove=event.target.closest('.cart-close-icon button');
      if(remove){event.preventDefault();const holder=remove.closest('[data-index]');if(holder)this.updateQuantity(holder.dataset.index,0);}
    }
    onChange(event){const input=event.target.closest('.quantity__input');if(input)this.updateQuantity(input.dataset.index,input.value,input.dataset.quantityVariantId)}
    async updateQuantity(line,quantity,variantId){
      if(!line)return;
      const row=this.querySelector(`#Quantity-${CSS.escape(String(line))}`)?.closest('.cart-notification-product');
      row?.classList.add('loading');
      try{
        const response=await fetch(route(window.routes?.cart_change_url,'/cart/change'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({line:Number(line),quantity:Math.max(0,Number(quantity)||0),sections:this.getSections(),sections_url:location.pathname})});
        const state=await response.json();
        if(!response.ok||state.errors)throw new Error(state.description||state.message||state.errors||'Cart update failed');
        this.renderContents(state,{open:false});
      }catch(error){const msg=row?.querySelector('.cart-item__error-text');if(msg)msg.textContent=error.message||'Unable to update your bag.';row?.querySelector('.cart-item__error')?.classList.remove('d-none');}
      finally{row?.classList.remove('loading')}
    }
  }
  if(!customElements.get('cart-notification'))customElements.define('cart-notification',AntarCartNotification);

  const showFormError=(form,message)=>{
    const wrapper=form.querySelector('.product-form__error-message-wrapper');
    if(!wrapper)return;
    const text=wrapper.querySelector('.product-form__error-message');if(text)text.textContent=message||'Unable to add this item.';
    wrapper.hidden=false;
  };
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('form[data-type="add-to-cart-form"]');
    if(!form)return;
    event.preventDefault();
    const drawer=document.getElementById('offcanvas__mini_cart');
    const button=form.querySelector('[type="submit"]');
    const wrapper=form.querySelector('.product-form__error-message-wrapper');if(wrapper)wrapper.hidden=true;
    if(button){button.disabled=true;button.classList.add('loading');}
    try{
      const data=new FormData(form);
      const sections=drawer?.getSections?.()||[];
      if(sections.length){data.set('sections',sections.join(','));data.set('sections_url',location.pathname);}
      const response=await fetch(route(window.routes?.cart_add_url,'/cart/add'),{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
      const state=await response.json();
      if(!response.ok||state.status)throw new Error(state.description||state.message||'Unable to add this item.');
      if(state.sections&&drawer?.renderContents){state.item_count=Number(String(state.sections['cart-notification-count']||'').replace(/<[^>]*>/g,'').trim())||undefined;drawer.renderContents(state,{open:true});}
      document.dispatchEvent(new CustomEvent('antar:product-added',{detail:{form,state,count:drawer?.getCount?.(state)}}));
    }catch(error){showFormError(form,error.message);}
    finally{if(button){button.disabled=false;button.classList.remove('loading');}}
  });
})();
